import getApiUrl from "../getApiUrl";

export const activityAPI = {
  send: (payload) =>
    getApiUrl.post('/activities/', payload),
  list: (params) =>
    getApiUrl.get('/activities/', {params}),
  history: (params) =>
    getApiUrl.get('/activities/history', {params}),
  search: (params) =>
    getApiUrl.get('/activities/search', {params}),
  revertFlag: (id) =>
    getApiUrl.patch(`/activities/${id}/revert-flag`)
};

export const formActivityAPI = {
  send: (payload) =>
    getApiUrl.post('/activities/form-activities/', payload),
  search: (payload) =>
    getApiUrl.post('/activities/form-activities/search', payload),
};
